import { render, staticRenderFns } from "./AgreementComments.vue?vue&type=template&id=65520267&"
import script from "./AgreementComments.vue?vue&type=script&lang=js&"
export * from "./AgreementComments.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports